import { FirebaseApp, getApps, initializeApp } from 'firebase/app'

var firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_ZOE_WEBSITE_APP_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
}

let firebaseApp: FirebaseApp

if (getApps.length === 0) {
  firebaseApp = initializeApp(firebaseConfig, 'ZoeWebsiteApp')
} else {
  firebaseApp = getApps()[0]
}

export default firebaseApp
